import {
  api,
  apiCall,
  apiActionDispatcher,
  multiIdApiActionDispatcher,
  multiIdApiCall,
  multiIdRequestCacheCheck,
  signalRWrappedApiCall
} from './api';
import {
  activeNodeIssuesActionTypes,
  nodeIssuesMarkInactiveTypes,
  nodeIssueTypesActionTypes
} from './types';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import { utils } from '../helpers';
import { toastr } from 'react-redux-toastr';

const fetchNodeActiveIssuesDispatcher = apiActionDispatcher({
  actionTypes: activeNodeIssuesActionTypes,
  useResponseErrorMessage: true
});
export const fetchNodeActiveIssues = () => signalRWrappedApiCall(
  apiCall(
    fetchNodeActiveIssuesDispatcher,
    api.nodesIssues.fetchActiveNodeIssues
  ),
  fetchNodeActiveIssuesDispatcher,
  signalRHubManager,
  subscriptionTypes.activeNodeIssues
);

const fetchNodeIssueTypesDispatcher =
  multiIdApiActionDispatcher({
    actionTypes: nodeIssueTypesActionTypes,
    responseHandler: (response) => utils.propertyReducer(
      response,
      (issueType) => issueType.id,
      (issueType) => issueType
    )
  });
export const fetchNodeIssueTypes = (typeIds) => multiIdApiCall(
  fetchNodeIssueTypesDispatcher,
  api.nodesIssues.fetchNodeIssueTypes,
  (state, ids) => multiIdRequestCacheCheck(state.nodeIssues.types.request, ids),
  typeIds
);

const markSingleInactiveDispatcher = apiActionDispatcher({
  actionTypes: nodeIssuesMarkInactiveTypes,
  responseHandler: (isSuccess) => {
    if (isSuccess) {
      toastr.success('Ack Succeeded');
    }
    else {
      toastr.warning('Ack Failed', 'Active issue failed to be marked');
    }
  }
});
export const markSingleInactive = (id) => apiCall(
  markSingleInactiveDispatcher,
  api.nodesIssues.markSingleInactive,
  null,
  null,
  null,
  [id]
);

const markMultipleInactiveDispatcher = apiActionDispatcher({
  actionTypes: nodeIssuesMarkInactiveTypes,
  responseHandler: (successCount) => {
    if (successCount === 0) {
      toastr.success('Multiple Ack Succeeded');
    }
    else {
      toastr.warning('Ack Failed', 'A portion of the issues were not marked as expected');
    }
  }
});
export const markMultipleInactive = (ids) => apiCall(
  markMultipleInactiveDispatcher,
  api.nodesIssues.markMultipleInactive,
  null,
  null,
  null,
  [ids]
);

export const SET_NODE_ISSUES_SELECTED = 'SET_NODES_ISSUES_SELECTED';
export const setNodeIssuesSelected = (selected) => {
  return {
    type: SET_NODE_ISSUES_SELECTED,
    selected
  };
};

export const SET_NODE_ISSUES_SELECTED_FOR_ACK = 'SET_NODE_ISSUES_SELECTED_FOR_ACK';
export const setNodeIssuesSelectedForAck = (selectedForAck) => {
  return {
    type: SET_NODE_ISSUES_SELECTED_FOR_ACK,
    selectedForAck
  };
};

export const SET_NODE_ISSUES_FILTERED = 'SET_NODE_ISSUES_FILTERED';
export const setNodeIssuesFiltered = (filtered) => {
  return {
    type: SET_NODE_ISSUES_FILTERED,
    filtered
  };
};

export const SORT_NODE_ISSUE_TABLE = 'SORT_NODE_ISSUE_TABLE';
export const sortNodeIssueTable = (sortingKey) => {
  return {
    type: SORT_NODE_ISSUE_TABLE,
    sortingKey
  };
};

export const SET_NODE_ISSUE_SEARCH = 'SET_NODE_SEARCH';
export const setNodeIssueSearch = (searched) => {
  return {
    type: SET_NODE_ISSUE_SEARCH,
    searched
  };
};


// WEBPACK FOOTER //
// src/actions/nodeIssues.js